import produce from 'immer';

import {
  SET_DARK_MODE,
  SET_ACCOUNT
} from 'app/actions/types';

import {
  ME,
  LOGOUT
} from 'shared/actions/types';

const initialState = {
  darkMode: false,
  account: {
    feature_flags: {}
  }
}

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_DARK_MODE:
      return produce(state, draft => {
        draft.darkMode = action.payload;
      });

    case SET_ACCOUNT:
      return produce(state, draft => {
        draft.account = action.payload;
        draft.account.feature_flags = draft.account.feature_flags || {}  // handling undefined feature flags
      });

    case ME:
      return produce(state, draft => {
        draft.account = action.payload.account || { feature_flags: {} };
      });

    case LOGOUT:
      return produce(state, draft => {
        draft.account = {};
      });

    default:
      return state;
  }
}
